// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3scNt","content":"styles_content__2jBnx","tableWrap":"styles_tableWrap__1M0hp"};